import { Directive } from "@angular/core";
import { NzListLoadMoreDirective } from "ng-zorro-antd/list";

@Directive({
  selector: "ui-list-load-more",
  exportAs: "uiListLoadMoreDirective",
  standalone: true,
})
export class UiListLoadMoreDirective extends NzListLoadMoreDirective {}
